module.exports = "<div class=\"filter-header-mobile\">\r\n    <bws-banner banner-list=\"banners\" ng-if=\"banners\"></bws-banner>\r\n    <div style=\"padding: 0 12px\">\r\n        <button ng-click=\"togglePanel()\" class=\"btn btn-primary btn--full-width\" wow-open-close-panel=\"left\" ng-show=\"filtersService.filters.length!=0 && filtersService.resultCount!=0\">Filter products</button>\r\n    </div>\r\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/filters/filter-header-mobile-template.html
 ** module id = 939
 ** module chunks = 1
 **/